/**
 * The frame of a list screen: the section header on the canvas, then the list,
 * which fills what is left of the screen (hybrid-3c §3 "one-screen fit"). From
 * `sm` up the frame is exactly as tall as the content column, so the table
 * scrolls inside its own frame with the header row and the pagination pinned;
 * on a phone the page scrolls naturally.
 */

import React from 'react';
import { Box } from '@mui/material';

export interface ListScreenProps {
  /** The screen's `SectionHeader`. */
  header: React.ReactNode;
  /** The react-admin `<List>` (or any content that should take the remaining height). */
  children: React.ReactNode;
}

export const ListScreen: React.FC<ListScreenProps> = ({ header, children }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      height: { sm: '100%' },
      '& > :first-of-type': { flexShrink: 0 },
    }}
  >
    {header}
    {children}
  </Box>
);

export default ListScreen;
